module.exports = __webpack_public_path__ + "img/identity.9c5e9d89.svg";